import { curry } from 'ramda';

export function initAccessDataStorage() {
  return {
    setData(access) {
      localStorage.setItem('access', JSON.stringify(access));
    },
    getData() {
      return JSON.parse(localStorage.getItem('access') || '{}');
    },
  };
}

export function makeAccessData({ isFreeEvent = false, wasPaid = false } = {}) {
  return {
    isFreeEvent,
    wasPaid,
  };
}

export function hasFullAccess(access) {
  return access.isFreeEvent || access.wasPaid;
}

function isStockImage(photo) {
  return photo?.stock_image_uid !== null && photo?.stock_image_uid !== undefined;
}

function shouldApplyWatermarkForStockImage(photo) {
  const value = photo?.stock_image_apply_watermark ?? photo?.stockImageApplyWatermark;
  return value === true || value === 1 || value === '1' || value === 'true';
}

export function isEnabledWatermarkBySrc(src) {
  const labelWM = 'nwm845';
  return !src.includes(labelWM);
}

export const isAvailableToUsePhoto = curry((access, photo) => {
  if (hasFullAccess(access)) return true;

  if (isStockImage(photo)) {
    return !shouldApplyWatermarkForStockImage(photo);
  }

  return !isEnabledWatermarkBySrc(photo.full_path);
});

export function getWatermarkSrc(access, photo, watermarkSrc = null) {
  if (!isAvailableToUsePhoto(access, photo)) return watermarkSrc;
  return null;
}

export function initWatermarkStorage() {
  return {
    setSrc(src) {
      localStorage.setItem('watermarkSrc', src);
    },
    getSrc() {
      return localStorage.getItem('watermarkSrc');
    },
  };
}
